import { catchError, EMPTY } from 'rxjs';

export function handleErrors() {
    return catchError(err => {
        console.error(err);
        let errorsEl = findErrorContainer();
        errorsEl.textContent = errorMessage(err);
        errorsEl.classList.remove('hidden');
        setTimeout(() => {
            // disable all inputs in setTimeout so we are hopefully
            // executed after all view logic.
            disableAllInputs();
        }, 10);
        return EMPTY;
    });
}

function findErrorContainer() {
    for (let selector of ['#view-container .errors', '#errors']) {
        let container = document.querySelector(selector);
        if (!container) {
            continue;
        }
        return container;
    }
    console.warn('No error container found.');
    return document.body;
}

function errorMessage(err) {
    if (err instanceof Response) {
        return `${err.status} ${err.statusText} with ${err.url}`;
    }
    try {
        return JSON.stringify(err);
    } catch(e) {}
    return '' + err;
}

function disableAllInputs() {
    for (let el of document.querySelectorAll('button, input, select, textarea')) {
        el.disabled = true;
    }
}
